export enum MarketCategory {
  BOOST = 'boosts',
  COSTUME = 'costumes',
  COSTUME_TOMORROW = 'tomorrow_costumes',
  COSTUME_SEASONAL = 'seasonal_costumes', // Limited Time Parts which can be purchased without base parts
  CURRENCY = 'currencies',
  PAINT = 'paints',
  MONOPAINT = 'monopaints',
  DUOPAINT = 'duopaints',
  TRIPAINT = 'tripaints',
  PART = 'parts',
  HAT = 'hats'
}

export type PaintSubCategory = MarketCategory.MONOPAINT | MarketCategory.DUOPAINT | MarketCategory.TRIPAINT;
